import { gql, useMutation } from "@apollo/client";
import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { ContextUser } from "../../../../context/ContextUser";
import { Toast } from "../../../../hooks/toast";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Applications",
    to: "#",
  },
  {
    text: "Products",
    to: "#",
  },
  {
    text: "Sponsor Product",
    to: "/sponsor/list",
  },
  {
    text: "Create",
    to: "/sponsor/create",
  },
];

const MUTATION_CREATE = gql`
  mutation merchantCreateSponsor(
    $name: String
    $itemIds: [String]
    $amount: String
  ) {
    merchantCreateSponsor(name: $name, itemIds: $itemIds, amount: $amount)
  }
`;

/*
const QUERY_SEARCH_PRODUCT = gql`
  query merchantSearchProduct($keyword: String) {
    merchantSearchProduct(keyword: $keyword)
  }
`;
*/

export function SponsorCreateScreen() {
  const context = useContext(ContextUser);
  const { push } = useHistory();
  const [codeInput, setCodeInput] = useState("");
  // const [keyword, setKeyWord] = useState("");
  const [items, setItems] = useState<any[]>([]);

  const [state, setState] = useState({
    name: "",
    amount: "",
  });

  const [merchantCreateSponsor] = useMutation(MUTATION_CREATE, {
    onCompleted: (data) => {
      if (data.merchantCreateSponsor) {
        push("/sponsor/list");
      }
    },
  });

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    const data = {
      name: state.name,
      amount: state.amount,
      itemIds: items.map((x) => x.itemid + ""),
    };
    if (
      Number(data.amount) > Number(context.merchant.balance) ||
      Number(data.amount) === 0
    ) {
      Toast.onShow(
        "We cannot create new sponsor for you! Somthing worng on balance lower than amount input or amount input is zero.",
        "danger",
        "right"
      );
    } else if (items.length === 0) {
      // setMessage("No item select for sponsor.");
      // setStatus("danger");
    } else {
      merchantCreateSponsor({
        variables: data,
      });
    }
  };

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock title="Create Sponsor" transparent={true}>
            <form onSubmit={handleOnSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <label className="text-success">
                    Balance: {context.merchant.balance} USD
                  </label>
                </div>
                <div className="col-md-6 text-right">
                  <button type="submit" className="btn btn-primary btn-sm">
                    Create
                  </button>
                </div>
              </div>
              <br />
              <div className="form-group">
                <label>Sponsor Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter sponsor name"
                  required
                  autoFocus
                  value={state.name}
                  onChange={(e) => setState({ ...state, name: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Sponsor Amount</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter sponsor amount"
                  required
                  value={state.amount}
                  onChange={(e) =>
                    setState({ ...state, amount: e.target.value })
                  }
                />
              </div>
            </form>
            <div className="form-group">
              <label>L192 Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter L192 code and press enter"
                value={codeInput}
                onChange={(e) => setCodeInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    // setKeyWord(codeInput);
                    setCodeInput("");
                  }
                }}
              />
            </div>
            <table className="table table-padded">
              <tbody>
                {items.map((x: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td>
                        <div className="cell-image-list">
                          <div
                            className="cell-img"
                            style={{
                              backgroundImage: `url(${x.thumb_small})`,
                            }}
                          ></div>
                        </div>
                        <small style={{ marginLeft: 20 }}>{x.code}</small>
                      </td>
                      <td className="text-center">
                        <Link
                          to="#"
                          className="text-danger"
                          onClick={() => {
                            setItems(
                              items.filter(
                                (item: any) => item.itemid !== x.itemid
                              )
                            );
                          }}
                        >
                          Remove
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
